import React from 'react';

/**
 * Renders the backgroun of magical strings and their history
 */
const About = () => {
  return (
    <section className="about">
      <h2 className="about__title">About Magical Strings</h2>
      <p className="about__blurb">
        Founded by Pam and Philip Boulding, Magical Strings has been sharing the
        joy of Celtic music and dance in the lives of people around the United
        States and abroad since 1978. They have recorded 21 albums encompassing
        traditional Celtic arrangements, original compositions and subtle world
        music influences, performing on their own crafted Celtic harps and
        hammered dulcimers, augmented with pennywhistles, button accordion,
        concertina and more. They have toured and collaborated with notable
        artists such as singer/songwriter Dan Fogelberg and slack-key guitarist
        Keola Beamer. When not on the road, Philip and Pam teach, build
        instruments, compose, and seem to have boundless energy for their
        creative life which is nurtured at their home, Magic Hill, on a
        beautiful farm by the Puget Sound.
      </p>
    </section>
  );
};

export default About;
